<template>
  <title-tab 
    :msg="$t('title.prize')"
    :had-data="hadData"
  >
    <div
      class="back-bt flex items-center gap-2 rounded-lg p-2 text-base"
      @click="goToResule"
    >
      <button
        id="back-btn-x"
        class="icon"
        type="button"
      >
        <div class="flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="#fff"
            width="24"
            height="24"
          ><path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 19.5L8.25 12l7.5-7.5"
          ></path></svg>
        </div>
      </button>ย้อนกลับ
    </div>
    <div
      v-for="game in lotto"
      :key="game.id"
    >
      <div class="game-type px-2">
        <div>
          <v-img 
            width="20"
            :src="imagePath(game.game_id, game.name)"
          />
        </div>
        <span class="py-1 mx-3 white--text ">{{ game.name }}</span>
      </div>

      <OnlyFourNumberDetail
        v-if="layout == 'only-four'"
        :game="game"
      ></OnlyFourNumberDetail>
      <ThaiLottoDetail
        v-else-if="layout == 'lotto'"
        :game="game"
      ></ThaiLottoDetail>
      <ThreeColumnDetail
        v-else-if="layout == 'three'"
        :game="game"
      ></ThreeColumnDetail>
      <TwoColumnDetail
        v-else
        :game="game"
      ></TwoColumnDetail>
    </div>
  </title-tab>
</template>
<script>
import {
  IsYeekeeType,    
  CARD_ONE_COLUMN,
  CARD_TWO_COLUMN,
  CARD_FOUR_COLUMN
} from '@/const/gameId'
import ThaiLottoDetail from '@/views-v2/Prize/childs/ThaiLottoDetail'
import TwoColumnDetail from '@/views-v2/Prize/childs/TwoColumnDetail'
import ThreeColumnDetail from '@/views-v2/Prize/childs/ThreeColumnDetail'
import OnlyFourNumberDetail from '@/views-v2/Prize/childs/OnlyFourNumberDetail'
import { st as apiSt, anonymous as apiAnonymous } from '@/apis'
import { FOREIGN_LOTTO } from '../../const/gameId'
import {
  ROUTE_RESULT,
} from '@/const/route'
import { imagePath } from '@/plugins/mapImage' 

export default {
  components:{ ThaiLottoDetail, TwoColumnDetail, ThreeColumnDetail, OnlyFourNumberDetail },
  data: () => ({
    gameTypeId: null,
    layout: null,
    lotto: [],
    games: [],
    hadData: true,
  }), 
  async created () {
    this.gameTypeId = this.$route.params.id;
    this.layout = this.$route.query.layout;
    this.getResultGame(null)
  },
  methods : {
    imagePath,
    IsYeekeeType, 
    isCardTwoColumn (id) {
      return CARD_TWO_COLUMN.includes(id)
    },
    isCardFourColumn (id) {
      return CARD_FOUR_COLUMN.includes(id)
    },
    isCardOneColumn (id) {
      return CARD_ONE_COLUMN.includes(id)
    },
    isfiveColumnGame (item) {
      return item.win_number && item.four
    },
    isCardTwoColumnGame (item) {
      return item.two_down && item.three_up && !item.four
    },
    isCardOneColumnGame (item) {
      return item.four && !item.two_down
    },
    isThreePlusColumnGame (item) {
      return !item.win_number && item.four && item.two_down && item.three_up
    },
    isCardThereColumn (id) {
      return [FOREIGN_LOTTO].includes(id)
    },
    expand (){
      this.expandStatus = !this.expandStatus
      this.GA('expand','')
    },
    async load () {
      const [err,data] = await apiAnonymous.getLastWin()

      if(err) {
        return
      }

      this.games = data
    },

    async getResultGame (dateRange) { 
      //reset and load
      this.lotto=[]

      dateRange = dateRange ? dateRange : ['','']

      console.log(dateRange)
      let params = {}
      // if(IsYeekeeType(this.selectItem.game_type_id)) {
      //   params.game_type_id = this.selectItem.game_type_id
      //   params.start_date = dateRange[0]
      //   params.end_date = dateRange[0]
      //   if (dateRange[0] == '') {
      //     return
      //   }
      // }

      // if(this.selectItem.id && !IsYeekeeType(this.selectItem.game_type_id)) params.game_id = this.selectItem.id  

      params.game_id = this.gameTypeId

      this.hadData = false  
      const [err,data] = await apiSt.getWinNumber(params)
      this.hadData = true

      
      if(err || !data) {
        return
      }

      this.lotto = data 
    },

    goToResule () {
      this.$router.push({name: ROUTE_RESULT})
      window.scrollTo(0,0);
    }
  } 
}
</script>
<style scoped>

.game-type {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
  background-color: #606060;
  border-radius: 8px;
  font-size: 18px;
  background-color: var(--bg-secondary-color-v2);
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  background-color: rgba(var(--color-primary));
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  position: relative;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}

.btn.icon, [type=button].icon, [type=submit].icon, button.icon {
  height: 2rem;
  min-height: 2rem;
  padding: 0;
  width: 2rem;
}

.back-bt {
  cursor: pointer;
}

#back-btn-x {
  background: radial-gradient(ellipse at center top, #383838, #171717);
}

</style>